"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAttendeeCancellationMockData = exports.buildAuctionOrganizationBidSubmittedMockData = exports.buildAuctionFailedPaymentMockData = exports.buildAuctionClosedMockData = exports.buildCheckInManagerUpcomingEventMockData = exports.buildTipsUpcomingEventMockData = void 0;
const organization_facing_base_1 = require("./organization-facing-base");
const buildTipsUpcomingEventMockData = ({ locale = "en", subject = "Tips for your upcoming event", accessLink = "https://www.zeffy.com/en-US/o/event-manager", emailerLink = "https://www.zeffy.com/en-US/o/emails", appStoreUrl = "https://apps.apple.com/us/app/zeffy-tap-to-pay/id1668842941", playStoreUrl = "https://play.google.com/store/apps/details?id=com.zeffy.taptopay", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    accessLink,
    emailerLink,
    appStoreUrl,
    playStoreUrl,
});
exports.buildTipsUpcomingEventMockData = buildTipsUpcomingEventMockData;
const buildCheckInManagerUpcomingEventMockData = ({ locale = "en", subject = "Your check-in manager is ready", accessLink = "https://www.zeffy.com/en-US/o/event-manager", eventTitle = "Spring Gala 2026", appStoreUrl = "https://apps.apple.com/us/app/zeffy-tap-to-pay/id1668842941", playStoreUrl = "https://play.google.com/store/apps/details?id=com.zeffy.taptopay", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    accessLink,
    eventTitle,
    appStoreUrl,
    playStoreUrl,
});
exports.buildCheckInManagerUpcomingEventMockData = buildCheckInManagerUpcomingEventMockData;
const buildAuctionClosedMockData = ({ locale = "en", subject = "Your auction has closed", formTitle = "Spring Charity Auction 2026", totalAmountRaised = "$18,450.00", totalAmountSaved = "$553.50", auctionPaymentLink = "https://www.zeffy.com/en-US/o/auction/payments", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    formTitle,
    totalAmountRaised,
    totalAmountSaved,
    auctionPaymentLink,
});
exports.buildAuctionClosedMockData = buildAuctionClosedMockData;
const AUCTION_BID_ITEMS = [
    { itemName: "Signed Team Jersey", itemPrice: "$320.00", isAutoBid: true, bidLabel: "Highest bid" },
    { itemName: "Weekend Cabin Getaway", itemPrice: "$1,150.00" },
];
const AUCTION_BID_QUESTIONS = [
    { question: "How did you hear about this auction?", answer: "From a friend" },
    { question: "Any dietary restrictions?", answer: "Vegetarian" },
];
const buildAuctionFailedPaymentMockData = ({ locale = "en", subject = "Oops! One of your bidders payments failed.", firstName = "Jane", lastName = "Donor", email = "jane.donor@example.com", items = "Signed Team Jersey, Weekend Cabin Getaway", amount = "$1,470.00", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    lastName,
    email,
    items,
    amount,
});
exports.buildAuctionFailedPaymentMockData = buildAuctionFailedPaymentMockData;
const buildAuctionOrganizationBidSubmittedMockData = ({ locale = "en", subject = "New bid submitted on your auction", orgName = "Bright Futures Foundation", auctionName = "Spring Charity Auction 2026", firstName = "Jane", lastName = "Donor", email = "jane.donor@example.com", items = AUCTION_BID_ITEMS, additionalQuestions = AUCTION_BID_QUESTIONS, formLink = "https://www.zeffy.com/en-US/auction/spring-charity-auction-2026", referralLink = "https://www.zeffy.com/en-US/referral?code=MOCK1234", referralAmount = "$50", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    orgName,
    auctionName,
    firstName,
    lastName,
    email,
    items,
    additionalQuestions,
    formLink,
    referralLink,
    referralAmount,
});
exports.buildAuctionOrganizationBidSubmittedMockData = buildAuctionOrganizationBidSubmittedMockData;
const buildAttendeeCancellationMockData = ({ locale = "en", subject = "An attendee freed up their spot", adminFirstName = "Jordan", buyerFirstName = "Sammy", buyerLastName = "Lee", eventTitle = "Bead Making Fundraiser", cancelledLines = [
    { name: "General Admission", number: 16, isAddOn: false },
    { name: "General Admission", number: 17, isAddOn: false },
    { name: "Parking Ticket", number: 8, isAddOn: true },
], guestListUrl = "https://www.zeffy.com/en-US/o/fundraising/campaigns/hub?tab=guest", paymentUrl = "https://www.zeffy.com/en-US/o/all-payments", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    adminFirstName,
    buyerFirstName,
    buyerLastName,
    eventTitle,
    cancelledLines,
    cancelledCount: cancelledLines.length,
    isSingleCancellation: cancelledLines.length === 1,
    guestListUrl,
    paymentUrl,
});
exports.buildAttendeeCancellationMockData = buildAttendeeCancellationMockData;
